// extracted by mini-css-extract-plugin
export default {"questionContainer":"IssueQuestions_questionContainer__oQxIG","questionBox":"IssueQuestions_questionBox__4s+kZ","answers":"IssueQuestions_answers__2L8ES"};